import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faSync, faEye, faArrowUp, faPen, faSearch, faArrowDown, faPrint } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import { fetchUsuario, getUsuario } from '../../user';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './PedidosData.css'
import './PedidosDataViev.css'
import 'jspdf-autotable';
import baseURL from '../../url';
import moneda from '../../moneda';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useLocation } from 'react-router-dom';
import { Link as Anchor } from 'react-router-dom';
import NewPedido from '../NewPedido/NewPedido'
import contador from '../../contador'
export default function PedidosData() {
    const [pedidos, setPedidos] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [nuevoEstado, setNuevoEstado] = useState('');
    const [pagado, setPagado] = useState('');
    const [pedido, setPedido] = useState({});
    const [selectedSection, setSelectedSection] = useState('texto');
    const [tienda, setTienda] = useState([]);
    const [filtroId, setFiltroId] = useState('');
    const [filtroNombre, setFiltrNombre] = useState('');
    const [filtroEstado, setFiltroEstado] = useState('');
    const [filtroDesde, setFiltroDesde] = useState('');
    const [filtroHasta, setFiltroHasta] = useState('');
    const [filtroPago, setFiltroPago] = useState('');
    const [filtroPagado, setFiltroPagado] = useState('');
    const [filtroEntrega, setFiltroEntrega] = useState('');
    const [ordenInvertido, setOrdenInvertido] = useState(false);
    const [detallesVisibles, setDetallesVisibles] = useState({});
    const [metodos, setMetodos] = useState([]);
    const [mesas, setMesas] = useState([]);
    const location = useLocation();
    const [visibleCount, setVisibleCount] = useState(20);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [pedidoEditando, setPedidoEditando] = useState(null);
    const [productosEditados, setProductosEditados] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [productosDisponibles, setProductosDisponibles] = useState([]);
    const [totalEditado, setTotalEditado] = useState(0);
    const [mostrarItemPersonalizado, setMostrarItemPersonalizado] = useState(false);
    const [pagoDividido, setPagoDividido] = useState(false);
    const [metodosPago, setMetodosPago] = useState([]);
    const [itemNombre, setItemNombre] = useState('');
    const [itemPrecio, setItemPrecio] = useState('');
    const [loadingUsuario, setLoadingUsuario] = useState(true);
    const [metodoPagoSeleccionado, setMetodoPagoSeleccionado] = useState('');
    const [estadoCargando, setEstadoCargando] = useState(null);
    const productosFiltrados = productosDisponibles.filter(p =>
        p.titulo.toLowerCase().includes(busqueda.toLowerCase())
    );

    const botonesEstadoComanda = [
        { estado: 'Cocina', label: 'Cocina', color: '#C9842A' },
        { estado: 'Recepcion', label: 'Recepción', color: '#7B2FBE' },
        { estado: 'Finalizado', label: 'Finalizado', color: '#2E9B4A' },
    ];
    const fuenteCocina = '"Inter", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

    useEffect(() => {
        const id = 'fuente-cocina-inter';
        if (document.getElementById(id)) return;

        const link = document.createElement('link');
        link.id = id;
        link.rel = 'stylesheet';
        link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@500;600;700;800&display=swap';
        document.head.appendChild(link);
    }, []);

    useEffect(() => {
        const cargarUsuario = async () => {
            await fetchUsuario();
            setLoadingUsuario(false);
        };

        cargarUsuario();
    }, []);

    const usuarioLegued = getUsuario();
    const handleShowMore = () => {
        setVisibleCount(prevCount => prevCount + 20);
    };


    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`)
            .then(res => res.json())
            .then(data => {
                setProductosDisponibles(data.productos || []);
            });
    };

    useEffect(() => {

        if (!pedidoEditando) return;

        console.log("🟡 Abriendo editor de pedido");

        const productos = parseProductos(pedidoEditando.productos);
        setProductosEditados(productos);

        // 🔥 MULTIPAGO FLAG
        setPagoDividido(pedidoEditando.pago_dividido === 1);

        // 🔥 SIEMPRE reconstruir desde catálogo de métodos
        const baseMetodos = metodos.map(m => ({
            idMetodo: m.idMetodo,
            tipo: m.tipo,
            monto: 0
        }));

        if (pedidoEditando.pagos && pedidoEditando.pagos.length > 0) {

            const nuevos = baseMetodos.map(m => {
                const encontrado = pedidoEditando.pagos.find(
                    p => p.idMetodo === m.idMetodo
                );

                return {
                    ...m,
                    monto: encontrado ? Number(encontrado.monto) : 0
                };
            });

            setMetodosPago(nuevos);

        } else {
            setMetodosPago(baseMetodos);
        }

    }, [pedidoEditando, metodos]);

    useEffect(() => {

        const total = productosEditados.reduce((acc, prod) => {
            return acc + (Number(prod.precio) * Number(prod.cantidad));
        }, 0);

        setTotalEditado(total);

    }, [productosEditados]);
    useEffect(() => {
        cargarPedidos();
        cargarTienda();
        cargarMetodos();
        cargarMesas();
        cargarProductos(); // 👈 IMPORTANTE
    }, []);


    const inicializarMetodos = (metodosBase) => {
        return metodosBase.map(m => ({
            idMetodo: m.idMetodo,
            tipo: m.tipo,
            monto: 0
        }));
    };

    const getMesaNombre = (idMesa) => {
        const mesa = mesas.find(m => m.idMesa === idMesa);
        return mesa ? mesa.mesa : null;
    };

    const etiquetaEntrega = (item) => {
        const mesa = getMesaNombre(item.idMesa);
        if (mesa) return String(mesa).toUpperCase();

        const entrega = String(item?.entrega || '').trim();

        if (entrega === 'Sucursal' || entrega === 'Retiro en Sucursal') {
            return 'RETIRO';
        }

        if (
            !entrega ||
            /^https?:\/\//i.test(entrega) ||
            /maps/i.test(entrega) ||
            entrega.toLowerCase() === 'domicilio' ||
            entrega.toLowerCase() === 'delivery'
        ) {
            return 'DELIVERY';
        }

        return entrega.toUpperCase();
    };

    const lineasOpcionales = (producto) => {
        const origen = Array.isArray(producto?.items) ? producto.items : [];
        const lineas = [];

        origen.forEach((op) => {
            if (typeof op === 'string') {
                lineas.push({ grupo: '', nombre: op });
                return;
            }

            if (!op || typeof op !== 'object') return;

            if (Array.isArray(op.items)) {
                op.items.forEach((it) => {
                    const nombre = typeof it === 'object'
                        ? (it.nombre || it.item || '')
                        : String(it ?? '');

                    if (!nombre) return;

                    lineas.push({
                        grupo: op.grupo || '',
                        nombre,
                    });
                });
                return;
            }

            const nombre = op.item || op.nombre || '';
            if (!nombre) return;

            lineas.push({
                grupo: op.grupo || '',
                nombre,
            });
        });

        return lineas;
    };

    const textoTotal = (total) => {
        const numero = Number(total);
        const valor = Number.isFinite(numero) ? numero.toFixed(2) : total;
        return `${moneda} ${valor}`.replace(/\s+/g, ' ').trim();
    };

    const cargarPedidos = () => {
        fetch(`${baseURL}/pedidoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setPedidos(data.pedidos.reverse() || []);
            })
            .catch(error => console.error('Error al cargar pedidos:', error));
    };

    const cargarMesas = () => {
        fetch(`${baseURL}/mesaGet.php`, {
            method: 'GET',
        })
            .then(res => res.json())
            .then(data => {
                setMesas(data.mesas || []);
            })
            .catch(err => console.error(err));
    };


    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTienda(data.tienda.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const cargarMetodos = () => {
        fetch(`${baseURL}/metodoGet.php`)
            .then(res => res.json())
            .then(data => {

                const metodosActivos =
                    (data.metodos || []).filter(m => m.estado === 'Activo');

                setMetodos(metodosActivos);

                // 🔥 IMPORTANTE: base para multipago
                setMetodosPago(inicializarMetodos(metodosActivos));
            });
    };

    const eliminar = (idPedido) => {

        if (loadingUsuario) return;

        if (usuarioLegued?.rol !== 'admin') {
            Swal.fire(
                '¡Sin permisos!',
                'Solo un administrador puede eliminar pedidos.',
                'error'
            );
            return;
        }

        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {

            if (result.isConfirmed) {

                fetch(`${baseURL}/pedidoDelete.php?idPedido=${idPedido}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {

                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje,
                            'success'
                        );

                        cargarPedidos();

                    })
                    .catch(error => {

                        console.error('Error al eliminar:', error);
                        toast.error(error);

                    });
            }
        });
    };
    useEffect(() => {
        setNuevoEstado(pedido.estado)
        setPagado(pedido.pagado)
    }, [pedido]);

    const abrirModal = (item) => {

        try {
            const productosParseados = parseProductos(item.productos);

            productosParseados.forEach((prod, index) => {
            });

        } catch (e) {
            console.error("ERROR PARSEANDO PRODUCTOS", e);
        }

        setPedido(item);
        setNuevoEstado(item.estado);
        setPagado(item.pagado);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };


    const abrirEditarPedido = (item) => {

        setPedidoEditando(item);

        // ==========================================
        // CARGAR MÉTODO DE PAGO
        // ==========================================

        const pagoDivididoActual =
            Number(item.pago_dividido) === 1;

        setPagoDividido(pagoDivididoActual);


        if (!pagoDivididoActual) {

            // Pago normal
            setMetodoPagoSeleccionado(
                item.pago || ''
            );

            // Limpiar pagos divididos
            setMetodosPago(prev =>
                prev.map(m => ({
                    ...m,
                    monto: 0
                }))
            );

        } else {

            // ==========================================
            // CARGAR PAGOS DIVIDIDOS
            // ==========================================

            try {

                let pagosGuardados = [];

                if (item.pagos) {

                    pagosGuardados =
                        typeof item.pagos === 'string'
                            ? JSON.parse(item.pagos)
                            : item.pagos;

                }

                console.log(
                    "💰 PAGOS DIVIDIDOS:",
                    pagosGuardados
                );


                setMetodosPago(prev => {

                    return prev.map(metodo => {

                        const pagoEncontrado =
                            pagosGuardados.find(
                                pago =>
                                    String(pago.idMetodo) ===
                                    String(metodo.idMetodo)
                            );

                        return {
                            ...metodo,

                            monto: pagoEncontrado
                                ? Number(pagoEncontrado.monto || 0)
                                : 0
                        };

                    });

                });


            } catch (error) {

                console.error(
                    "Error cargando pagos divididos:",
                    error
                );

                setMetodosPago(prev =>
                    prev.map(m => ({
                        ...m,
                        monto: 0
                    }))
                );

            }

            // En pago dividido no usamos
            // el método de pago normal
            setMetodoPagoSeleccionado('');
        }


        // ==========================================
        // CARGAR PRODUCTOS
        // ==========================================

        try {

            const productos =
                parseProductos(item.productos);

            console.log(
                "PRODUCTOS DEL PEDIDO:",
                productos
            );

            setProductosEditados(productos);


            const total =
                productos.reduce(
                    (acc, producto) =>
                        acc +
                        Number(producto.precio) *
                        Number(producto.cantidad),
                    0
                );

            setTotalEditado(total);


        } catch (error) {

            console.error(
                "Error cargando productos",
                error
            );

            setProductosEditados([]);

            setTotalEditado(0);
        }


        // ==========================================
        // ABRIR MODAL
        // ==========================================

        setEditModalVisible(true);
    };

    const guardarCambios = () => {

        console.log("🟡 guardarCambios ejecutado");

        // ==========================================
        // VALIDAR MÉTODO DE PAGO NORMAL
        // ==========================================

        if (!pagoDividido && !metodoPagoSeleccionado) {

            Swal.fire(
                "Datos incompletos",
                "Debes seleccionar un método de pago.",
                "warning"
            );

            return;
        }


        // ==========================================
        // VALIDACIÓN SI ES MULTIPAGO
        // ==========================================

        if (pagoDividido) {

            const suma = metodosPago.reduce(
                (acc, m) => acc + Number(m.monto || 0),
                0
            );

            if (
                Number(suma.toFixed(2)) !==
                Number(totalEditado.toFixed(2))
            ) {

                Swal.fire(
                    "Error",
                    "La suma de pagos no coincide con el total",
                    "error"
                );

                return;
            }
        }


        // ==========================================
        // PAYLOAD
        // ==========================================

        const payload = {

            idPedido: pedidoEditando.idPedido,

            productos: JSON.stringify(productosEditados),

            total: totalEditado,

            pago_dividido: pagoDividido ? 1 : 0,

            pago: pagoDividido
                ? 'Personalizado'
                : metodoPagoSeleccionado,

            pagos: pagoDividido
                ? metodosPago.filter(
                    m => Number(m.monto || 0) > 0
                )
                : null
        };


        console.log(
            "📦 PAYLOAD ENVIADO:",
            payload
        );


        // ==========================================
        // ENVIAR AL PHP
        // ==========================================

        fetch(`${baseURL}/pedidoupdatefull.php`, {

            method: "POST",

            headers: {
                "Content-Type": "application/json"
            },

            body: JSON.stringify(payload)

        })

            .then(res => res.json())

            .then(data => {

                console.log(
                    "🟢 RESPUESTA PHP:",
                    data
                );


                if (data.error) {

                    Swal.fire(
                        "Error",
                        data.error,
                        "error"
                    );

                    return;
                }


                Swal.fire(
                    "¡Editado!",
                    data.mensaje,
                    "success"
                );


                setEditModalVisible(false);

                cargarPedidos();

            })

            .catch(error => {

                console.error(
                    "🔴 Error al guardar:",
                    error
                );

                Swal.fire(
                    "Error",
                    "No se pudieron guardar los cambios.",
                    "error"
                );

            });

    };

    const agregarProductoAlPedido = (producto) => {

        if (!producto) return;


        setProductosEditados(prev => {

            const existe = prev.find(
                p => p.idProducto === producto.idProducto
            );


            let nuevos;


            if (existe) {

                nuevos = prev.map(p =>
                    p.idProducto === producto.idProducto
                        ? {
                            ...p,
                            cantidad: Number(p.cantidad) + 1
                        }
                        : p
                );


            } else {

                nuevos = [
                    ...prev,
                    {
                        idProducto: producto.idProducto,
                        idCategoria: producto.idCategoria,
                        titulo: producto.titulo,
                        precio: Number(producto.precio),
                        cantidad: 1,
                        imagen: producto.imagen1 || producto.imagen2 || null,
                        items: [],
                        personalizado: false
                    }
                ];

            }


            // actualizar total
            const nuevoTotal = nuevos.reduce(
                (acc, item) =>
                    acc + Number(item.precio) * Number(item.cantidad),
                0
            );

            setTotalEditado(nuevoTotal);


            return nuevos;

        });

    };

    const agregarItemPersonalizado = () => {

        if (!itemNombre.trim()) {
            toast.error("Ingrese nombre");
            return;
        }

        const precio = Number(itemPrecio);

        if (isNaN(precio)) {
            toast.error("Precio inválido");
            return;
        }

        const nuevoItem = {
            idProducto: `custom_${Date.now()}`,
            idCategoria: null,
            titulo: itemNombre,
            precio: precio,
            cantidad: 1,
            imagen: null,
            items: [],
            personalizado: true
        };

        const nuevosProductos = [
            ...productosEditados,
            nuevoItem
        ];

        setProductosEditados(nuevosProductos);

        const nuevoTotal = nuevosProductos.reduce(
            (acc, item) =>
                acc + Number(item.precio) * Number(item.cantidad),
            0
        );

        setTotalEditado(nuevoTotal);

        setItemNombre('');
        setItemPrecio('');

        setMostrarItemPersonalizado(false);
    };

    const handleUpdateText = (idPedido) => {

        const estadoFinal = nuevoEstado !== ''
            ? nuevoEstado
            : pedido.estado;


        const payload = {
            estado: estadoFinal,
            pagado: pagado !== '' ? pagado : pedido.pagado,
        };
        fetch(`${baseURL}/pedidoPut.php?idPedido=${idPedido}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    Swal.fire(
                        'Error!',
                        data.error,
                        'error'
                    );
                } else {
                    Swal.fire(
                        'Editado!',
                        data.mensaje,
                        'success'
                    );
                    cargarPedidos();
                    cerrarModal();
                }
            })
            .catch(error => {
                console.log(error.message);
                toast.error(error.message);
            });
    };

    const cambiarEstado = (item, estado) => {
        if (!item?.idPedido || !estado) return;
        if (estadoCargando) return;
        if (item.estado === estado) return;

        const estadoAnterior = item.estado;
        setEstadoCargando(item.idPedido);

        setPedidos(prev =>
            prev.map(p =>
                p.idPedido === item.idPedido
                    ? { ...p, estado }
                    : p
            )
        );

        if (pedido?.idPedido === item.idPedido) {
            setPedido(prev => ({ ...prev, estado }));
            setNuevoEstado(estado);
        }

        fetch(`${baseURL}/pedidoupdatefull.php`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                accion: 'estado',
                idPedido: item.idPedido,
                estado,
                pagado: item.pagado,
            }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    setPedidos(prev =>
                        prev.map(p =>
                            p.idPedido === item.idPedido
                                ? { ...p, estado: estadoAnterior }
                                : p
                        )
                    );

                    if (pedido?.idPedido === item.idPedido) {
                        setPedido(prev => ({ ...prev, estado: estadoAnterior }));
                        setNuevoEstado(estadoAnterior);
                    }

                    Swal.fire(
                        'Error!',
                        data.error,
                        'error'
                    );
                    return;
                }

                toast.success(data.mensaje || 'Estado actualizado');
            })
            .catch(error => {
                console.error('Error al cambiar estado:', error);

                setPedidos(prev =>
                    prev.map(p =>
                        p.idPedido === item.idPedido
                            ? { ...p, estado: estadoAnterior }
                            : p
                    )
                );

                toast.error('No se pudo cambiar el estado');
            })
            .finally(() => {
                setEstadoCargando(null);
            });
    };



    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };

    const filtrados = pedidos.filter(item => {
        const idMatch = item.idPedido?.toString().includes(filtroId);
        const estadoMatch = !filtroEstado || item.estado?.includes(filtroEstado);
        const nombreMatch = !filtroNombre || item.nombre?.toLowerCase().includes(filtroNombre.toLowerCase());
        const desdeMatch = !filtroDesde || new Date(item.createdAt) >= new Date(filtroDesde);
        const pagoMatch = !filtroPago || item.pago?.includes(filtroPago);
        const pagadoMatch = !filtroPagado || item.pagado?.includes(filtroPagado);
        // Incrementamos la fecha "hasta" en un día para que incluya la fecha seleccionada
        const adjustedHasta = new Date(filtroHasta);
        adjustedHasta.setDate(adjustedHasta.getDate() + 1);
        const hastaMatch = !filtroHasta || new Date(item.createdAt) < adjustedHasta;

        // Ajustar el filtro de entrega
        const entregaMatch = !filtroEntrega ||
            (filtroEntrega === "Domicilio"
                ? item?.entrega !== "Sucursal" && item?.entrega !== "Retiro en Sucursal"
                : item.entrega?.includes(filtroEntrega));

        return idMatch && estadoMatch && desdeMatch && hastaMatch && nombreMatch && pagoMatch && entregaMatch && pagadoMatch;
    });


    const recargar = () => {
        cargarPedidos();
    };
    const invertirOrden = () => {
        setPedidos([...pedidos].reverse());
        setOrdenInvertido(!ordenInvertido);
    };


    const parseProductos = (productos) => {
        if (!productos) return [];

        if (typeof productos === 'string') {
            try {
                return JSON.parse(productos);
            } catch (e) {
                console.error("Error parseando productos", e);
                return [];
            }
        }

        if (Array.isArray(productos)) return productos;

        return [];
    };


    const descargarExcel = () => {
        let totalGeneral = 0;

        const data = filtrados.map(item => {
            const total = parseFloat(item.total); // Convertir a número
            totalGeneral += total;
            const productos = parseProductos(item.productos);
            const infoProductos = productos.map(producto => `${producto.titulo} - ${moneda}${producto.precio} - x${producto.cantidad}  `);
            return {
                'ID Pedido': item.idPedido,
                'Estado': item.estado,
                'Pagado': item.pagado,
                'Nombre': item.nombre,
                'Telefono': item.telefono,
                'Pago': item.pago,
                'Entrega': item.entrega,
                'Nota': item.nota,
                'Productos': infoProductos.join('\n'),
                'Codigo': item.codigo,
                'Total': Number(total.toFixed(2)),
                'Fecha': item.createdAt,
            };
        });

        // Formatear el total general
        const formattedTotal = Number(totalGeneral.toFixed(2));

        // Agregar fila con el total general
        const totalRow = {

            'ID Pedido': '',
            'Estado': '',
            'Nombre': '',
            'Telfono': '',
            'Pago': '',
            'Entrega': '',
            'Nota': '',
            'Productos': '',
            'Codigo': 'Total General:',
            'Total': formattedTotal,
            'Fecha': '',
        };

        data.push(totalRow);

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'pedidos');
        XLSX.writeFile(wb, 'pedidos.xlsx');
    };


    const descargarPDF = () => {
        const pdf = new jsPDF('landscape'); // Orientación horizontal
        pdf.text('Lista de Pedidos', 10, 10);

        const columns = [
            { title: 'ID Pedido', dataKey: 'idPedido' },
            { title: 'Estado', dataKey: 'estado' },
            { title: 'Pagado', dataKey: 'pagado' },
            { title: 'Nombre', dataKey: 'nombre' },
            { title: 'Telfono', dataKey: 'telefono' },
            { title: 'Pago', dataKey: 'pago' },
            { title: 'Entrega', dataKey: 'entrega' },
            { title: 'Nota', dataKey: 'nota' },
            { title: 'Productos', dataKey: 'productos' },
            { title: 'Codigo', dataKey: 'codigo' },
            { title: 'Total', dataKey: 'total' },
            { title: 'Fecha', dataKey: 'createdAt' },
        ];

        let totalGeneral = 0;

        const data = filtrados.map(item => {
            const total = parseFloat(item.total); // Convertir a número
            totalGeneral += total;
            const productos = parseProductos(item.productos);
            const infoProductos = productos.map(producto => `${producto.titulo} - ${moneda}${producto.precio} - x${producto.cantidad}  `);
            return {
                idPedido: item.idPedido,
                estado: item.estado,
                pagado: item.pagado,
                nombre: item.nombre,
                telefono: item.telefono,
                pago: item.pago,
                entrega: item.entrega,
                nota: item.nota,
                productos: infoProductos.join('\n'),
                codigo: item.codigo,
                total: `${moneda} ${total.toFixed(2)}`,
                createdAt: item.createdAt,
            };
        });

        // Formatear el total general
        const formattedTotal = `${moneda} ${totalGeneral.toFixed(2)}`;

        // Agregar fila con el total general
        const totalRow = {
            idPedido: '',
            estado: '',
            nombre: '',
            telefono: '',
            pago: '',
            entrega: '',
            nota: '',
            productos: '',
            codigo: 'Total General:',
            total: formattedTotal,
            createdAt: '',
        };

        data.push(totalRow);

        pdf.autoTable({
            head: [columns.map(col => col.title)],
            body: data.map(item => Object.values(item)),
        });

        pdf.save('pedidos.pdf');
    };
    const handleDownloadPDF = () => {
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        let y = 10;

        // Agregar título
        pdf.setFontSize(10);


        // Obtener los detalles del pedido actualmente mostrado en el modal
        const pedidoActual = pedido;


        // Agregar detalles del pedido al PDF
        const notaFormateada = pdf.splitTextToSize(pedidoActual.nota || '', 120);

        const pedidoData = [
            [`ID Pedido:`, `${pedidoActual.idPedido}`],
            [`Estado:`, `${pedidoActual.estado}`],
            [`Pagado:`, `${pedidoActual.pagado}`],
            [`Nombre:`, `${pedidoActual.nombre}`],
            [`Telefono:`, `${pedidoActual.telefono}`],
            [`Pago:`, `${pedidoActual.pago}`],
            [`Entrega:`, `${pedidoActual.entrega}`],
            [`Nota:`, notaFormateada],
            [`Código:`, `${pedidoActual.codigo}`],
            [`Total:`, `${moneda} ${pedidoActual.total}`],
            [`Fecha:`, `${pedidoActual.createdAt}`]
        ];

        pdf.autoTable({
            startY: y,
            head: [['Detalle del pedido', 'Valor']],
            body: pedidoData
        });
        y = pdf.autoTableEndPosY() + 5;

        // Obtener los productos del pedido actual
        const productosPedido = parseProductos(pedidoActual.productos);

        // Generar sección de productos con imágenes y contenido
        for (let i = 0; i < productosPedido.length; i++) {
            if (y + 30 > pdf.internal.pageSize.getHeight()) {
                pdf.addPage();
                y = 10;
            }

            const producto = productosPedido[i];

            pdf.setFontSize(8);

            // Muestra la imagen a la izquierda de los datos del producto
            if (producto.imagen) {
                pdf.addImage(producto.imagen, 'JPEG', 15, y, 20, 20); // Ajusta el tamaño de la imagen aquí
            } else {
                // Si no hay URL de imagen, simplemente dejar un espacio en blanco
                pdf.text("Imagen no disponible", 5, y + 15);
            }

            if (producto) {
                pdf.text(`Producto: ${producto.titulo}`, 39, y + 3);
                pdf.text(`Precio: ${moneda} ${producto.precio}`, 39, y + 11);
                pdf.text(`Cantidad: ${producto.cantidad}`, 39, y + 15);
                pdf.text(`${producto.items}`, 39, y + 19);
            }

            y += 25; // Incrementar y para la siguiente posición
        }

        // Guardar el PDF
        pdf.save('pedido.pdf');
    };

    const imprimirTicket = () => {
        let totalGeneral = 0;

        const pdf = new jsPDF({
            unit: 'mm',
            format: [80, 150], // Tamaño de ticket estándar
        });

        // Recorrer los pedidos filtrados y sumar los totales
        filtrados.forEach((item, index) => {
            // Si no es el primer pedido, agregar una nueva página
            if (index > 0) {
                pdf.addPage();
            }

            const total = parseFloat(item.total); // Convertir a número
            totalGeneral += total;

            // Extraer productos y formatearlos
            const productos = parseProductos(item.productos);

            // Encabezado del ticket
            pdf.setFontSize(11);
            pdf.text(`${tienda?.nombre}`, 40, 10, { align: 'center' });
            pdf.setFontSize(10);
            pdf.text(`Tel: ${tienda?.telefono}`, 40, 16, { align: 'center' });
            const fechaFormateada = `${new Date(item?.createdAt)?.toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            })} ${new Date(item?.createdAt)?.toLocaleTimeString('es-ES', {
                hour: '2-digit',
                minute: '2-digit'
            })}`;

            pdf.text(`Fecha: ${fechaFormateada}`, 40, 22, { align: 'center' });

            let y = 35; // Posición inicial para los datos de los pedidos

            // Añadir información del pedido al PDF
            pdf.setFontSize(9);
            pdf.text(`ID Pedido: ${item.idPedido}`, 5, y);
            pdf.text(`Cliente: ${item.nombre}`, 5, y + 5);
            pdf.text(`Teléfono: ${item.telefono}`, 5, y + 10);
            pdf.text(`Entrega: ${item.entrega}`, 5, y + 15);
            pdf.text(`Pago: ${item.pago}`, 5, y + 20);
            pdf.text(`Pago al recibirlo: ${item.pagoRecibir || ''}`, 5, y + 25);
            pdf.text(`Estado: ${item.estado}`, 5, y + 30);
            pdf.text(`Pagado: ${item.pagado}`, 5, y + 35);
            pdf.text(`Código descuento: ${item.codigo}`, 5, y + 40);
            pdf.text(`Nota: ${item.nota}`, 5, y + 45);
            pdf.text(`------------------------------------------------------------------`, 5, y + 50);
            pdf.text(`Productos:`, 5, y + 54);

            // Añadir productos del pedido
            let yProductos = y + 59;
            productos.forEach((producto) => {
                // Asegurarse de que optionals sea un array
                let opcionales = [];
                try {
                    opcionales = Array.isArray(producto.optionals)
                        ? producto.optionals
                        : JSON.parse(producto.optionals || "[]");
                } catch (e) {
                    opcionales = [];
                    console.error("Error parseando optionals:", e);
                }

                // Unir los opcionales en una sola línea, separados por comas
                let subtotalOpcionales = 0;

                let lineasOpcionales = [];

                opcionales.forEach(op => {
                    const grupo = op.grupo || 'Opcional';

                    if (!Array.isArray(op.items)) return;

                    op.items.forEach(item => {

                        // soporta ambos formatos:
                        // string simple o objeto
                        let nombre = '';
                        let precio = 0;

                        if (typeof item === 'object') {
                            nombre = item.nombre || item.item || '';
                            precio = parseFloat(item.precio || 0);
                        } else {
                            nombre = item;
                            precio = 0;
                        }

                        subtotalOpcionales += precio;

                        lineasOpcionales.push({
                            grupo,
                            texto: `${nombre} +${moneda}${precio.toFixed(2)}`
                        });
                    });
                });

                // Agregar título, precio, cantidad
                pdf.setFontSize(9);
                const tituloTexto = `- ${producto.titulo} x${producto.cantidad} - ${moneda}${producto.precio}`;
                pdf.text(tituloTexto, 5, yProductos);
                yProductos += 5;

                // Agregar los opcionales debajo del producto (si existen)
                if (lineasOpcionales.length > 0) {
                    if (lineasOpcionales.length > 0) {

                        pdf.setFontSize(8);
                        pdf.text(`Opcionales:`, 7, yProductos);
                        yProductos += 4;

                        let currentGrupo = '';

                        lineasOpcionales.forEach(op => {

                            if (op.grupo !== currentGrupo) {
                                currentGrupo = op.grupo;
                                pdf.setFontSize(8);
                                pdf.text(`  ${currentGrupo}:`, 9, yProductos);
                                yProductos += 4;
                            }

                            pdf.text(`    ${op.texto}`, 11, yProductos);
                            yProductos += 4;
                        });

                        // subtotal opcionales
                        if (subtotalOpcionales > 0) {
                            pdf.setFontSize(8);
                            pdf.text(
                                `  Subtotal opcionales: ${moneda}${subtotalOpcionales.toFixed(2)}`,
                                9,
                                yProductos
                            );
                            yProductos += 5;
                        }
                    }
                }

                // Cambiar a un tamaño de fuente de 8 para los items


                // Verificar si se necesita agregar nueva página
                if (yProductos > 145) { // Ajusta este número si es necesario, 145 es el límite de altura de la página
                    pdf.addPage();
                    yProductos = 10; // Reiniciar la posición vertical
                }
            });

            // Total del pedido
            y = yProductos + 5;
            pdf.text(`-----------------------------------------------------`, 5, y - 5);
            pdf.setFontSize(10);
            pdf.text(`Total: ${moneda}${total.toFixed(2)}`, 5, y);

            // Mensaje de agradecimiento
            y += 10;
            pdf.text("¡Gracias por su compra!", 40, y, { align: 'center' });
        });

        // Imprimir el ticket
        window.open(pdf.output('bloburl'), '_blank'); // Abre el ticket en una nueva pestaña para imprimir
    };


    const agregarCampo = (pdf, etiqueta, valor, yPos, minLineas = 2, sinDosPuntos = false) => {
        let yLocal = yPos;
        const maxWidth = 70; // ancho máximo del ticket
        const lineHeight = 3.5; // altura entre líneas más compacta

        // Determinar texto según si queremos los dos puntos o no
        const texto = sinDosPuntos
            ? (etiqueta ? `${etiqueta} ${valor}` : valor)
            : `${etiqueta}: ${valor}`;

        let lineas = pdf.splitTextToSize(texto, maxWidth);

        // Garantizar al menos minLineas saltos
        while (lineas.length < minLineas) lineas.push('');

        lineas.forEach(line => {
            pdf.text(line, 5, yLocal);
            yLocal += lineHeight;
        });

        return yLocal; // nueva posición vertical
    };
    const imprimirTicket2 = (pedido) => {
        const pdf = new jsPDF({
            unit: 'mm',
            format: [80, 150], // Tamaño de ticket estándar
        });

        const total = parseFloat(pedido.total); // Convertir a número
        let productos = [];

        // Verificar si "productos" existe y es un JSON válido antes de intentar parsearlo
        if (pedido.productos) {
            try {
                productos = JSON.parse(pedido.productos);
            } catch (error) {
                console.error("Error al parsear productos:", error);
            }
        }

        // Encabezado del ticket
        pdf.setFontSize(11);
        pdf.text(`${tienda?.nombre}`, 40, 10, { align: 'center' });
        pdf.setFontSize(10);
        pdf.text(`Tel: ${tienda?.telefono}`, 40, 16, { align: 'center' });

        const fechaFormateada = `${new Date(pedido?.createdAt)?.toLocaleDateString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        })} ${new Date(pedido?.createdAt)?.toLocaleTimeString('es-ES', {
            hour: '2-digit',
            minute: '2-digit'
        })}`;

        pdf.text(`Fecha: ${fechaFormateada}`, 40, 22, { align: 'center' });

        let y = 35; // Posición inicial para los datos del pedido

        // Añadir información del pedido usando agregarCampo
        pdf.setFontSize(9);
        y = agregarCampo(pdf, '', 'Pedido Confirmado', y, 2, true);
        y = agregarCampo(pdf, 'Cliente', pedido.nombre, y);
        y = agregarCampo(pdf, 'Teléfono', pedido.telefono, y);
        y = agregarCampo(pdf, 'Entrega', pedido.entrega, y);
        y = agregarCampo(pdf, 'Pago', pedido.pago, y);
        if (pedido.pagoRecibir) y = agregarCampo(pdf, 'Pago a recibirlo', pedido.pagoRecibir, y);
        y = agregarCampo(pdf, 'Estado', pedido.estado, y);
        y = agregarCampo(pdf, 'Pagado', pedido.pagado, y);
        y = agregarCampo(pdf, 'Código descuento', pedido.codigo, y);
        y = agregarCampo(pdf, 'Nota', pedido.nota, y);
        // Separador y Productos (minLineas = 1 para evitar espacios extra)
        y = agregarCampo(pdf, 'Productos', '', y, 1);

        // Productos
        let yProductos = y; // empezar justo después de "Productos:"
        if (productos.length > 0) {
            productos.forEach((producto) => {

                const itemsTexto = producto.items && producto.items.length > 0
                    ? producto.items.join(', ')
                    : '';

                // Título del producto
                const tituloTexto = `- ${producto.titulo} x${producto.cantidad} - ${moneda}${producto.precio}`;
                pdf.setFontSize(9);
                pdf.text(tituloTexto, 5, yProductos);
                yProductos += 4;

                if (producto.items && producto.items.length > 0) {
                    pdf.setFontSize(8);

                    // Grupo si existe
                    if (producto.grupo) {
                        const grupoLines = pdf.splitTextToSize(`Grupo: ${producto.grupo}`, 75);
                        grupoLines.forEach(line => {
                            pdf.text(line, 5, yProductos);
                            yProductos += 4;
                        });
                    }

                    // Encabezado
                    const headerLines = pdf.splitTextToSize("Opcionales:", 75);
                    headerLines.forEach(line => {
                        pdf.text(line, 5, yProductos);
                        yProductos += 4;
                    });

                    // Normalizar estructura
                    let grupos = [];

                    producto.items.forEach(item => {
                        if (typeof item === 'object' && item !== null && item.grupo) {

                            if (item.item) {
                                grupos.push({
                                    grupo: item.grupo,
                                    items: [{
                                        nombre: item.item,
                                        precio: item.precio ?? 0
                                    }]
                                });
                            }

                            else if (Array.isArray(item.items)) {
                                grupos.push({
                                    grupo: item.grupo,
                                    items: item.items.map(it => {
                                        if (typeof it === 'object') {
                                            return {
                                                nombre: it.nombre || it.item || '',
                                                precio: parseFloat(it.precio || 0)
                                            };
                                        }
                                        return {
                                            nombre: it,
                                            precio: 0
                                        };
                                    })
                                });
                            }
                        }
                    });

                    // Imprimir opcionales
                    grupos.forEach(g => {
                        g.items.forEach(op => {

                            const precio = Number(op.precio || 0);

                            const linea =
                                `${g.grupo}: ${op.nombre}` +
                                (precio > 0 ? ` + ${moneda}${precio.toFixed(2)}` : '');

                            pdf.splitTextToSize(linea, 75).forEach(line => {
                                pdf.text(line, 5, yProductos);
                                yProductos += 4;
                            });
                        });
                    });
                }

                // Nueva página si se excede la altura
                if (yProductos > 145) {
                    pdf.addPage();
                    yProductos = 10;
                }
            });
        } else {
            pdf.text('No hay productos.', 5, yProductos);
            yProductos += 4;
        }

        y = yProductos; // continuar desde el final de los productos

        // Separador y total
        pdf.text(`-----------------------------------------------------`, 5, y);
        y += 4;
        pdf.setFontSize(10);
        pdf.text(`Total: ${moneda}${total.toFixed(2)}`, 5, y);

        y += 6;
        pdf.text("¡Gracias por su compra!", 40, y, { align: 'center' });

        // Imprimir el ticket
        window.open(pdf.output('bloburl'), '_blank');

    };

    const pedidosAgrupados = filtrados?.reduce((acc, item) => {
        acc[item.estado] = acc[item.estado] || [];
        acc[item.estado].push(item);
        return acc;
    }, {});

    // Filtramos los estados que deseas mostrar
    const estados = ['Cocina', 'Recepcion', 'Entregado', 'Finalizado', 'Rechazado'];
    const toggleDetalles = (idPedido) => {
        setDetallesVisibles((prev) => ({
            ...prev,
            [idPedido]: !prev[idPedido], // Alterna la visibilidad para este idPedido
        }));
    };
    const fechaActual = new Date();
    const diaActual = fechaActual.getDate();
    const mesActual = fechaActual.getMonth() + 1; // Los meses son indexados desde 0
    const anioActual = fechaActual.getFullYear();
    const pedidosFiltrados = Object.keys(pedidosAgrupados)?.reduce((acc, estado) => {
        const pedidosDelEstado = pedidosAgrupados[estado]?.filter(item => {
            const fechaPedido = new Date(item.createdAt);
            return (
                fechaPedido.getDate() === diaActual &&
                fechaPedido.getMonth() + 1 === mesActual &&
                fechaPedido.getFullYear() === anioActual
            );
        });
        if (pedidosDelEstado?.length > 0) {
            acc[estado] = pedidosDelEstado;
        }
        return acc;
    }, {});




    const cambiarCantidad = (index, cantidad) => {

        const copia = [...productosEditados];

        copia[index].cantidad = Number(cantidad);

        setProductosEditados(copia);
    };

    const eliminarProducto = (index) => {

        const copia = productosEditados.filter((_, i) => i !== index);

        setProductosEditados(copia);
    };

    //Contador de recarga de pedidos
    const [counter, setCounter] = useState(contador);
    const [isPaused, setIsPaused] = useState(false);
    useEffect(() => {
        const interval = setInterval(() => {
            if (!isPaused) {
                setCounter((prevCounter) => {
                    if (prevCounter === 1) {
                        recargar();
                        return contador;
                    }
                    return prevCounter - 1;
                });
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [isPaused]);
    const modalAbierto = modalVisible || editModalVisible;

    return (
        <div>

            <style>{`
                .pedidos-modal-capa {
                    position: fixed !important;
                    top: 0 !important;
                    right: 0 !important;
                    bottom: 0 !important;
                    left: 0 !important;
                    width: 100vw !important;
                    height: 100vh !important;
                    z-index: 100000 !important;
                    background: rgba(17, 24, 39, 0.55) !important;
                    overflow-y: auto !important;
                    box-sizing: border-box !important;
                }
                .ojo-comanda {
                    position: static !important;
                    z-index: auto !important;
                    top: auto !important;
                    right: auto !important;
                    float: none !important;
                }
                .comanda-cocina {
                    font-family: "Inter", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
                    background: #ffffff !important;
                    color: #161616 !important;
                    border: 1px solid #e7e7e7 !important;
                    border-radius: 12px !important;
                    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06) !important;
                    padding: 14px 14px 12px !important;
                    position: relative !important;
                    z-index: auto !important;
                    overflow: hidden !important;
                    width: 100% !important;
                    max-width: 100% !important;
                    box-sizing: border-box !important;
                    text-align: left !important;
                }
                .estado-container > h2.titulo-columna {
                    text-align: center !important;
                    font-family: "Inter", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
                    font-weight: 600 !important;
                    font-size: 18px !important;
                    color: #9aa0a6 !important;
                    margin: 8px 0 12px !important;
                }
            `}</style>
            <ToastContainer />
            <div className='deFlexContent2'>
                <div className='deFlex2'>
                    <NewPedido />
                    <button className='pdf' onClick={() => imprimirTicket(pedido)}>  <FontAwesomeIcon icon={faPrint} /> Tickets</button>
                    <button className='excel' onClick={descargarExcel}><FontAwesomeIcon icon={faArrowDown} /> Excel</button>
                    <button className='pdf' onClick={descargarPDF}><FontAwesomeIcon icon={faArrowDown} /> PDF</button>
                </div>
                <div className='filtrosContain'>
                    <div className='deFlexLink'>
                        <Anchor to={`/dashboard/pedidos`} className={location.pathname === '/dashboard/pedidos' ? 'activeLin' : ''}> Cuadrícula</Anchor>

                        <Anchor to={`/dashboard/pedidos/view`} className={location.pathname === '/dashboard/pedidos/view' ? 'activeLin' : ''}> Lista</Anchor>
                    </div>
                    <div className='inputsColumn'>
                        <button className='length'>{String(filtrados?.length)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")} / {String(pedidos?.length)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")} </button>
                    </div>
                    <div className='inputsColumn'>
                        <input type="number" value={filtroId} onChange={(e) => setFiltroId(e.target.value)} placeholder='Id Pedido' />
                    </div>
                    <div className='inputsColumn'>
                        <input type="text" value={filtroNombre} onChange={(e) => setFiltrNombre(e.target.value)} placeholder='Nombre' />
                    </div>
                    <div className='inputsColumn'>
                        <select value={filtroEstado} onChange={(e) => setFiltroEstado(e.target.value)}>
                            <option value="">Estado</option>

                            <option value="Cocina">
                                Cocina
                            </option>

                            <option value="Recepcion">
                                Recepcion
                            </option>

                            <option value="Entregado">
                                Entregado
                            </option>

                            <option value="Finalizado">
                                Finalizado
                            </option>

                            <option value="Rechazado">
                                Rechazado
                            </option>
                        </select>
                    </div>
                    <div className='inputsColumn'>
                        <select value={filtroPagado} onChange={(e) => setFiltroPagado(e.target.value)}>
                            <option value="">Pagado</option>
                            <option value="Si">Si</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                    <div className='inputsColumn'>
                        <select value={filtroPago} onChange={(e) => setFiltroPago(e.target.value)}>
                            <option value="">Pago</option>
                            {
                                metodos?.map(metod => (
                                    <option value={metod.tipo}>{metod.tipo}</option>
                                ))}
                        </select>

                    </div>
                    <div className='inputsColumn'>
                        <select value={filtroEntrega} onChange={(e) => setFiltroEntrega(e.target.value)}>
                            <option value="">Entrega</option>
                            <option value="Sucursal">Sucursal</option>
                            <option value="Retiro en Sucursal">Retiro en Sucursal</option>
                            <option value="Domicilio">Domicilio</option>
                        </select>
                    </div>
                    <button className='reload' onClick={recargar}><FontAwesomeIcon icon={faSync} /></button>
                    <button className='reverse' onClick={invertirOrden}>
                        {ordenInvertido ? <FontAwesomeIcon icon={faArrowUp} /> : <FontAwesomeIcon icon={faArrowDown} />}
                    </button>

                </div>

            </div>
            {location?.pathname === '/dashboard/pedidos' ? (
                <div className='cards-container'>
                    {estados?.map(estado => (
                        <div key={estado} className='estado-container'>
                            <h2 className="titulo-columna">{estado} ({pedidosFiltrados[estado]?.length || 0})</h2>

                            <div className='cards-row'>
                                {pedidosFiltrados[estado]?.map(item => {
                                    const productosComanda = parseProductos(item.productos);
                                    const notaTexto = String(item.nota || '').trim();
                                    const notaVacia = !notaTexto || notaTexto.toLowerCase() === 'sin notas';
                                    const entregaCruda = String(item.entrega || '').trim();
                                    const entregaUrl = /^https?:\/\//i.test(entregaCruda);
                                    const detalleAbierto = !!detallesVisibles[item.idPedido];
                                    const separador = {
                                        height: 1,
                                        background: '#ececec',
                                        border: 0,
                                        margin: '12px 0',
                                    };

                                    return (
                                    <div key={item.idPedido} className='card comanda-cocina' style={{ fontFamily: fuenteCocina }}>
                                        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12 }}>
                                            <div style={{ minWidth: 0, paddingRight: 4 }}>
                                                <div style={{ fontSize: 17, fontWeight: 800, lineHeight: 1.3, letterSpacing: '-0.01em', color: '#161616' }}>
                                                    CLIENTE: {item.nombre || 'Sin nombre'}
                                                </div>
                                                <div style={{ fontSize: 17, fontWeight: 800, lineHeight: 1.3, letterSpacing: '-0.01em', color: '#161616', marginTop: 2 }}>
                                                    ENTREGA: {etiquetaEntrega(item)}
                                                </div>
                                            </div>

                                            {!modalAbierto && (
                                                <button
                                                    type="button"
                                                    className="ojo-comanda"
                                                    title="Ver pedido"
                                                    onClick={() => abrirModal(item)}
                                                    style={{
                                                        position: 'static',
                                                        zIndex: 'auto',
                                                        width: 36,
                                                        height: 36,
                                                        minWidth: 36,
                                                        flex: '0 0 36px',
                                                        border: 'none',
                                                        borderRadius: 8,
                                                        background: '#7B2FBE',
                                                        color: '#fff',
                                                        cursor: 'pointer',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: 16,
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faEye} />
                                                </button>
                                            )}
                                        </div>

                                        <div style={separador} />

                                        <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 12 }}>
                                            <span style={{ fontSize: 16, fontWeight: 800, color: '#161616' }}>PEDIDO:</span>
                                            <span style={{ fontSize: 18, fontWeight: 800, color: '#1F9D4A', whiteSpace: 'nowrap' }}>
                                                {textoTotal(item.total)}
                                            </span>
                                        </div>

                                        <div style={{ marginTop: 8 }}>
                                            {productosComanda.map((producto, index) => (
                                                <div key={`${item.idPedido}-${index}`} style={{ marginTop: index === 0 ? 0 : 8 }}>
                                                    <div style={{ fontSize: 16, fontWeight: 600, lineHeight: 1.35, color: '#1c1c1c' }}>
                                                        {producto.titulo} x{producto.cantidad}
                                                    </div>
                                                    {lineasOpcionales(producto).map((linea, i) => (
                                                        <div key={i} style={{ fontSize: 16, fontWeight: 500, lineHeight: 1.35, color: '#1c1c1c', marginTop: 1 }}>
                                                            {linea.grupo && (
                                                                <strong style={{ fontWeight: 800 }}>{linea.grupo}: </strong>
                                                            )}
                                                            <span>{linea.nombre}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            ))}
                                        </div>

                                        <div style={separador} />

                                        <div style={{ fontSize: 16, fontWeight: 800, color: '#161616' }}>NOTAS:</div>
                                        <div style={{ fontSize: 16, fontWeight: 500, lineHeight: 1.35, color: notaVacia ? '#8b919a' : '#1c1c1c', marginTop: 2 }}>
                                            {notaVacia ? 'Sin notas' : notaTexto}
                                        </div>

                                        <div style={separador} />

                                        <button
                                            type="button"
                                            onClick={() => toggleDetalles(item.idPedido)}
                                            style={{
                                                border: 'none',
                                                background: 'transparent',
                                                color: '#7B2FBE',
                                                fontFamily: fuenteCocina,
                                                fontSize: 16,
                                                fontWeight: 700,
                                                padding: 0,
                                                cursor: 'pointer',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: 6,
                                            }}
                                        >
                                            {detalleAbierto ? 'Mostrar menos' : 'Mostrar más'}
                                            <span style={{ fontSize: 12 }}>{detalleAbierto ? '▴' : '▾'}</span>
                                        </button>

                                        {detalleAbierto && (
                                            <div style={{ marginTop: 10, fontSize: 15, lineHeight: 1.45, color: '#1c1c1c' }}>
                                                <div><strong>Id:</strong> {item.idPedido}</div>
                                                <div><strong>Fecha:</strong> {new Date(item?.createdAt)?.toLocaleString('es-ES', {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric'
                                                })}</div>
                                                <div><strong>Teléfono:</strong> {item.telefono || '—'}</div>
                                                <div><strong>Pago:</strong> {item.pago || '—'}</div>
                                                <div><strong>Pagado:</strong> {item.pagado || '—'}</div>
                                                {item.codigo ? <div><strong>Código:</strong> {item.codigo}</div> : null}
                                                {entregaUrl && (
                                                    <a
                                                        href={entregaCruda}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ color: '#7B2FBE', fontWeight: 700 }}
                                                    >
                                                        Ver ubicación
                                                    </a>
                                                )}
                                            </div>
                                        )}

                                        <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                                            {botonesEstadoComanda.map((btn) => {
                                                const activo = item.estado === btn.estado;
                                                const cargando = estadoCargando === item.idPedido;

                                                return (
                                                    <button
                                                        key={btn.estado}
                                                        type="button"
                                                        onClick={() => cambiarEstado(item, btn.estado)}
                                                        style={{
                                                            flex: '1 1 0',
                                                            minWidth: 0,
                                                            border: 'none',
                                                            borderRadius: 8,
                                                            background: btn.color,
                                                            color: '#fff',
                                                            fontFamily: fuenteCocina,
                                                            fontWeight: 800,
                                                            fontSize: 15,
                                                            lineHeight: 1.2,
                                                            padding: '12px 6px',
                                                            cursor: cargando ? 'wait' : activo ? 'default' : 'pointer',
                                                            boxShadow: activo ? 'inset 0 0 0 2px #ffffff' : 'none',
                                                            opacity: cargando ? 0.7 : 1,
                                                        }}
                                                    >
                                                        {btn.label}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className='table-container'>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>Id Pedido</th>
                                <th>Estado</th>
                                <th>Pagado</th>
                                <th>Nombre</th>
                                <th>Telefono</th>
                                <th>Entrega</th>
                                <th>Pago</th>
                                <th>Total</th>
                                <th>Fecha</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtrados?.slice(0, visibleCount)?.map(item => (
                                <tr key={item.idPedido}>
                                    <td>{item.idPedido}</td>

                                    <td style={{
                                        color:
                                            item.estado === 'Cocina' ? '#DAA520' :
                                                item.estado === 'Recepcion' ? '#0000FF' :
                                                    item.estado === 'Entregado' ? '#800080' :
                                                        item.estado === 'Finalizado' ? '#008000' :
                                                            item.estado === 'Rechazado' ? '#FF0000' :
                                                                '#3366FF'
                                    }}>
                                        {item?.estado}
                                    </td>

                                    <td style={{
                                        color: item?.pagado === 'Si' ? '#008000' : item?.pagado === 'No' ? '#FF0000' : ''
                                    }}>
                                        {item?.pagado}
                                    </td>

                                    <td>{item.nombre}</td>
                                    <td>{item.telefono}</td>
                                    <td>
                                        {getMesaNombre(item.idMesa) || item.entrega}
                                    </td>
                                    <td>{item.pago}</td>

                                    <td style={{ color: '#008000', }}>{moneda} {item.total}</td>
                                    <td> {new Date(item?.createdAt)?.toLocaleString('es-ES', {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                    })}</td>
                                    <td>
                                        <button
                                            className='eliminar'
                                            onClick={() => eliminar(item.idPedido)}
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>

                                        <button
                                            className='editar'
                                            onClick={() => abrirModal(item)}
                                        >
                                            <FontAwesomeIcon icon={faEye} />
                                        </button>

                                        <button
                                            className='editarPedido'
                                            onClick={() => abrirEditarPedido(item)}
                                        >
                                            <FontAwesomeIcon icon={faPen} />
                                        </button>

                                        <button
                                            onClick={() => imprimirTicket2(item)}
                                            className='editar'
                                        >
                                            <FontAwesomeIcon icon={faPrint} />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </table>

                </div>
            )}


            {location?.pathname === '/dashboard/pedidos' ? (
                <div> </div>
            ) : (
                <div>
                    {filtrados?.length > visibleCount && (
                        <button onClick={handleShowMore} id="show-more-btn">
                            Mostrar  más </button>
                    )}
                </div>
            )}

            {modalVisible && (
                <div className="modal pedidos-modal-capa">
                    <div className="modal-content" id='modal-content'>
                        <div className='deFlexBtnsModal'>
                            <div className='deFlexBtnsModal'>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Pedido
                                </button>
                                <button onClick={() => imprimirTicket2(pedido)} className='texto'>
                                    Imprimir Ticket
                                </button>
                                <button onClick={handleDownloadPDF} className='texto'>Descargar PDF</button>
                            </div>

                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>


                        <div className='sectiontext' style={{ display: selectedSection === 'texto' ? 'flex' : 'none' }}>
                            {/* 
                            <div style={{
                                width: '100%',
                                background: '#111',
                                color: '#0f0',
                                padding: '10px',
                                borderRadius: '10px',
                                marginBottom: '20px',
                                fontSize: '12px',
                                overflow: 'auto',
                                maxHeight: '300px'
                            }}>
                                <h3>DEBUG PEDIDO</h3>

                                <pre>
                                    {JSON.stringify(pedido, null, 2)}
                                </pre>

                                <h3>DEBUG PRODUCTOS</h3>

                                <pre>
                                    {
                                        pedido?.productos
                                            ? JSON.stringify(JSON.parse(pedido.productos), null, 2)
                                            : 'Sin productos'
                                    }
                                </pre>
                            </div>
                            */}

                            <div id='cardsProductData'>
                                {parseProductos(pedido.productos).map(producto => (
                                    <div key={producto.titulo} className='cardProductData'>
                                        <img
                                            src={
                                                producto.imagen
                                                    ? producto.imagen
                                                    : `${baseURL}imagenes_productos/default.png`
                                            }
                                            alt="imagen"
                                        />
                                        <div className='cardProductDataText'>
                                            <h3>{producto.titulo}</h3>

                                            <strong>
                                                {moneda} {producto.precio}
                                                <span> x{producto.cantidad}</span>
                                            </strong>

                                            <div>
                                                {(() => {
                                                    // 1. Normalizar productos igual que en ticket
                                                    const productos = Array.isArray(producto.items)
                                                        ? producto.items
                                                        : [];

                                                    if (!productos.length) return <span>Sin opcionales</span>;

                                                    // 2. Reconstruir grupos (igual lógica ticket)
                                                    const grupos = [];

                                                    productos.forEach((item) => {
                                                        if (typeof item === 'object' && item !== null && item.grupo) {

                                                            if (item.item) {
                                                                grupos.push({
                                                                    grupo: item.grupo,
                                                                    items: [{
                                                                        nombre: item.item,
                                                                        precio: Number(item.precio || 0)
                                                                    }]
                                                                });
                                                            }

                                                            else if (Array.isArray(item.items)) {
                                                                grupos.push({
                                                                    grupo: item.grupo,
                                                                    items: item.items.map(it => ({
                                                                        nombre: typeof it === 'object'
                                                                            ? (it.nombre || it.item)
                                                                            : it,
                                                                        precio: typeof it === 'object'
                                                                            ? Number(it.precio || 0)
                                                                            : 0
                                                                    }))
                                                                });
                                                            }
                                                        }
                                                    });

                                                    if (!grupos.length) return <span>Sin opcionales</span>;

                                                    // 3. Render FINAL igual que ticket
                                                    return grupos.map((g, index) => (
                                                        <div key={index}>
                                                            <strong>{g.grupo}:</strong>{' '}

                                                            {g.items.map((op, idx) => (
                                                                <span key={idx}>
                                                                    {op.nombre}
                                                                    {Number(op.precio) > 0 && (
                                                                        <span style={{ marginLeft: '4px' }}>
                                                                            +{moneda}{Number(op.precio).toFixed(2)}
                                                                        </span>
                                                                    )}
                                                                    {idx < g.items.length - 1 ? ', ' : ''}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    ));
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className='recibirAbsolute'>
                                {
                                    (pedido?.entrega === 'Sucursal' || pedido?.entrega === 'Retiro en Sucursal') ? (
                                        <span>Retira Personalmente</span>
                                    ) : (
                                        <span >Delivery</span>
                                    )

                                }

                                {
                                    pedido?.pagoRecibir === 'Si' ? (
                                        <span>Pago al recibirlo</span>
                                    ) : pedido?.pagado === 'No' || (!pedido?.pagoRecibir && pedido?.pagado === 'No') ? (
                                        <span>Falta Comprobante</span>
                                    ) : pedido?.pagado === 'Si' ? (
                                        <></>
                                    ) : (
                                        <></>
                                    )
                                }

                            </div>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>ID Pedido</legend>
                                    <input
                                        value={pedido.idPedido}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Fecha </legend>
                                    <input
                                        value={new Date(pedido?.createdAt)?.toLocaleString('es-ES', {
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric'
                                        })}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Nombre</legend>
                                    <input
                                        value={pedido.nombre}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Telefono</legend>
                                    <input
                                        value={pedido.telefono}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Pago</legend>
                                    <input
                                        value={pedido.pago}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Google Maps</legend>

                                    <a
                                        href={pedido.entrega}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="linkEntrega"
                                    >
                                        📍 Ver ubicación en Google Maps
                                    </a>
                                </fieldset>

                                <fieldset>
                                    <legend>Codigo</legend>
                                    <input
                                        value={pedido.codigo}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Nota</legend>
                                    <input
                                        value={pedido.nota}
                                        disabled

                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Entrega</legend>
                                    <input
                                        value={getMesaNombre(pedido.idMesa) || pedido.entrega}
                                        disabled
                                    />
                                </fieldset>

                                <div className="totalBox">

                                    <fieldset className="totalField">
                                        <legend>Total</legend>

                                        <input
                                            value={pedido.total}
                                            disabled
                                            className="inputTotal"
                                        />
                                    </fieldset>

                                    {
                                        pedido?.pago_dividido === 1 && pedido?.pagos && (
                                            <div className="pagoDivididoBox">
                                                <strong>Pago dividido:</strong>

                                                {pedido.pagos.map((p, i) => (
                                                    <div key={i}>
                                                        {p.tipo}: {moneda}{Number(p.monto).toFixed(2)}
                                                    </div>
                                                ))}
                                            </div>
                                        )
                                    }

                                </div>
                                <fieldset>
                                    <legend>Estado</legend>

                                    <div className='deFlexBtnsFilset'>

                                        <button
                                            type="button"
                                            className={
                                                nuevoEstado === 'Cocina' ||
                                                    (nuevoEstado === '' && pedido.estado === 'Cocina')
                                                    ? 'activo'
                                                    : 'Noactivo'
                                            }
                                            onClick={() => setNuevoEstado('Cocina')}
                                        >
                                            Cocina
                                        </button>


                                        <button
                                            type="button"
                                            className={
                                                nuevoEstado === 'Recepcion' ||
                                                    (nuevoEstado === '' && pedido.estado === 'Recepcion')
                                                    ? 'activo'
                                                    : 'Noactivo'
                                            }
                                            onClick={() => setNuevoEstado('Recepcion')}
                                        >
                                            Recepcion
                                        </button>


                                        <button
                                            type="button"
                                            className={
                                                nuevoEstado === 'Entregado' ||
                                                    (nuevoEstado === '' && pedido.estado === 'Entregado')
                                                    ? 'activo'
                                                    : 'Noactivo'
                                            }
                                            onClick={() => setNuevoEstado('Entregado')}
                                        >
                                            Entregado
                                        </button>


                                        <button
                                            type="button"
                                            className={
                                                nuevoEstado === 'Finalizado' ||
                                                    (nuevoEstado === '' && pedido.estado === 'Finalizado')
                                                    ? 'activo'
                                                    : 'Noactivo'
                                            }
                                            onClick={() => setNuevoEstado('Finalizado')}
                                        >
                                            Finalizado
                                        </button>


                                        <button
                                            type="button"
                                            className={
                                                nuevoEstado === 'Rechazado' ||
                                                    (nuevoEstado === '' && pedido.estado === 'Rechazado')
                                                    ? 'activo'
                                                    : 'Noactivo'
                                            }
                                            onClick={() => setNuevoEstado('Rechazado')}
                                        >
                                            Rechazado
                                        </button>

                                    </div>
                                </fieldset>

                                <fieldset id="fieldsetAuto">
                                    <legend>Pagado</legend>
                                    <div className='deFlexBtnsFilset'>
                                        <button
                                            type="button"
                                            className={pagado === 'Si' || (pagado === '' && pedido.pagado === 'Si') ? 'activo' : 'Noactivo'}
                                            onClick={() => setPagado('Si')}
                                        >
                                            Sí
                                        </button>
                                        <button
                                            type="button"
                                            className={pagado === 'No' || (pagado === '' && pedido.pagado === 'No') ? 'activo' : 'Noactivo'}
                                            onClick={() => setPagado('No')}
                                        >
                                            No
                                        </button>
                                    </div>
                                </fieldset>




                            </div>


                            <button className='btnPost' onClick={() => handleUpdateText(pedido.idPedido)} >Guardar </button>
                        </div>
                    </div>
                </div>
            )}


            {
                editModalVisible && (

                    <div className="modal pedidos-modal-capa">

                        <div className="modal-content">
                            <span
                                className="closeEditarPedido"
                                onClick={() =>
                                    setEditModalVisible(false)
                                }
                            >
                                ×
                            </span>

                            <h2>
                                Editar Pedido
                            </h2>

                            {/* BUSCADOR (SOLO UNA VEZ) */}
                            <div id="deFlexInputs">

                                <div className="search">

                                    <FontAwesomeIcon
                                        icon={faSearch}
                                        className="search-icon"
                                    />

                                    <input
                                        type="text"
                                        placeholder="Buscar producto..."
                                        value={busqueda}
                                        onChange={(e) => setBusqueda(e.target.value)}
                                        className="input"
                                    />

                                </div>

                            </div>

                            {
                                busqueda.trim() !== "" && (

                                    <div className="productsGrap">

                                        {
                                            productosFiltrados.length > 0 ? (

                                                productosFiltrados.map(producto => (

                                                    <div
                                                        key={producto.idProducto}
                                                        className="cardProductData"
                                                    >

                                                        <img
                                                            src={
                                                                producto.imagen1 ||
                                                                producto.imagen2 ||
                                                                `${baseURL}imagenes/default.png`
                                                            }
                                                            alt="producto"
                                                        />

                                                        <div className="cardProductDataText">

                                                            <h3>
                                                                {producto.titulo}
                                                            </h3>

                                                            <strong>
                                                                {moneda} {producto.precio}
                                                            </strong>


                                                            <button
                                                                className="btnSave"
                                                                onClick={() => {
                                                                    agregarProductoAlPedido(producto);
                                                                    setBusqueda('');
                                                                }}
                                                            >
                                                                Agregar
                                                            </button>


                                                        </div>

                                                    </div>

                                                ))

                                            ) : (

                                                <p>
                                                    No hay resultados
                                                </p>

                                            )
                                        }

                                    </div>

                                )
                            }

                            {/* LISTA DE PRODUCTOS DEL PEDIDO */}


                            <h4>
                                Productos del pedido
                            </h4>
                            <br />

                            <div className="productsGrap">

                                {
                                    productosEditados.map((producto, index) => (

                                        <div
                                            key={index}
                                            className="cardProductData"
                                        >

                                            <img
                                                src={
                                                    producto.imagen
                                                        ? producto.imagen
                                                        : `${baseURL}imagenes_productos/default.png`
                                                }
                                                alt="producto"
                                            />


                                            <div className="cardProductDataText">


                                                <h3>
                                                    {producto.titulo}
                                                </h3>


                                                <strong>
                                                    {moneda} {producto.precio}
                                                </strong>


                                                <div className="deFlexCart">


                                                    <button
                                                        onClick={() =>
                                                            cambiarCantidad(
                                                                index,
                                                                producto.cantidad - 1
                                                            )
                                                        }
                                                    >
                                                        -
                                                    </button>


                                                    <span>
                                                        {producto.cantidad}
                                                    </span>


                                                    <button
                                                        onClick={() =>
                                                            cambiarCantidad(
                                                                index,
                                                                producto.cantidad + 1
                                                            )
                                                        }
                                                    >
                                                        +
                                                    </button>


                                                    <button
                                                        onClick={() =>
                                                            eliminarProducto(index)
                                                        }
                                                    >
                                                        X
                                                    </button>


                                                </div>


                                            </div>


                                        </div>

                                    ))
                                }

                            </div>
                            <br />
                            <h3>
                                Total:
                                {moneda}
                                {totalEditado}

                            </h3>
                            <br />
                            <div className="botonesEditarPedido">

                                <div className="grupoBotonesEditar">
                                    <button
                                        className="btnGuardarEditar"
                                        onClick={guardarCambios}
                                    >
                                        Guardar
                                    </button>

                                    <button
                                        type="button"
                                        className="btnItemPersonalizado2"
                                        onClick={() =>
                                            setMostrarItemPersonalizado(!mostrarItemPersonalizado)
                                        }
                                    >
                                        + Item personalizado
                                    </button>
                                </div>


                                <div className="opcionesPedido">

                                    <label className="checkboxDividir">

                                        <input
                                            type="checkbox"
                                            checked={pagoDividido}
                                            onChange={(e) => {

                                                const checked = e.target.checked;

                                                setPagoDividido(checked);

                                                if (!checked) {

                                                    setMetodosPago(prev =>
                                                        prev.map(m => ({
                                                            ...m,
                                                            monto: 0
                                                        }))
                                                    );

                                                }

                                            }}
                                        />

                                        <span>
                                            Dividir pago
                                        </span>

                                    </label>

                                </div>


                                {/* MÉTODO DE PAGO SIN DIVIDIR */}
                                {
                                    !pagoDividido && (

                                        <div className="paymentBox">

                                            <h4>
                                                Método de pago
                                            </h4>

                                            <select
                                                className="selectMetodoPago"
                                                value={metodoPagoSeleccionado}
                                                onChange={(e) =>
                                                    setMetodoPagoSeleccionado(e.target.value)
                                                }
                                            >

                                                <option value="">
                                                    Selecciona un método de pago
                                                </option>

                                                {
                                                    metodosPago.map((m) => (

                                                        <option
                                                            key={m.idMetodo}
                                                            value={m.tipo}
                                                        >
                                                            {m.tipo}
                                                        </option>

                                                    ))
                                                }

                                            </select>

                                        </div>

                                    )
                                }


                                {/* MÉTODOS DE PAGO DIVIDIDOS */}
                                {
                                    pagoDividido && (

                                        <div className="paymentBox">

                                            <h4>
                                                Dividir pago
                                            </h4>

                                            <div className="paymentGrid">

                                                {
                                                    metodosPago.map((m, index) => (

                                                        <div
                                                            key={m.idMetodo}
                                                            className="paymentRow"
                                                        >

                                                            <label>
                                                                {m.tipo}
                                                            </label>

                                                            <input
                                                                type="number"
                                                                value={m.monto}
                                                                onChange={(e) => {

                                                                    const copy = [...metodosPago];

                                                                    copy[index].monto =
                                                                        Number(e.target.value || 0);

                                                                    setMetodosPago(copy);

                                                                }}
                                                            />

                                                        </div>

                                                    ))
                                                }

                                            </div>

                                            <strong>
                                                Total ingresado: {
                                                    metodosPago.reduce(
                                                        (a, b) =>
                                                            a + Number(b.monto || 0),
                                                        0
                                                    )
                                                }
                                            </strong>


                                        </div>
                                    )
                                }

                            </div>

                            {
                                mostrarItemPersonalizado && (

                                    <div className="itemPersonalizadoBox">

                                        <input
                                            className="inputItemPersonalizado"
                                            type="text"
                                            placeholder="Nombre"
                                            value={itemNombre}
                                            onChange={(e) => setItemNombre(e.target.value)}
                                        />

                                        <input
                                            className="inputItemPersonalizado"
                                            type="number"
                                            placeholder="Precio"
                                            value={itemPrecio}
                                            onChange={(e) => setItemPrecio(e.target.value)}
                                        />

                                        <button
                                            type="button"
                                            className="btnAgregarItem"
                                            onClick={agregarItemPersonalizado}
                                        >
                                            Agregar Item
                                        </button>

                                    </div>

                                )
                            }

                        </div>

                    </div>

                )
            }
        </div>
    );
};
